import styled from 'styled-components';
import CustomScrollbar from 'components/CustomScrollbar';
import { blurBox } from 'styles/parcelSharedStyles';

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const NoInfoBox = styled(CustomScrollbar)`
  ${blurBox};
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;
